module.exports = __webpack_public_path__ + "static/img/logo.c53ce0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 22